import 'react-quill/dist/quill.snow.css';

import React from 'react';
import ReactQuill from 'react-quill';

function ReleaseNoteEditor({
 submitDisabled, setSubmitDisabled, releaseNotes, setReleaseNotes,
}) {
  const spanRef = React.useRef(null);
  const [inEdit, setInEdit] = React.useState(false);
  React.useEffect(() => {
    if (spanRef.current) {
      spanRef.current.innerHTML = releaseNotes;
    }
  }, [releaseNotes]);

  React.useEffect(() => {
    if (releaseNotes !== '') { setInEdit(true); }
     }, []);

  const handleReleaseNotesChange = (e) => {
    if (inEdit === false) {
    const { value } = e.target;
    setReleaseNotes(value);
    if (value && value.length > 0) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  } else {
    const { value } = e.target;
    setReleaseNotes(value);
  }
  };

  return (
    <div>
      {inEdit === false ? (
        <div>
          <ReactQuill
            value={releaseNotes}
            theme="snow"
            onChange={(newValue) => {
              const val = newValue === '<p><br></p>' ? '' : newValue;
              handleReleaseNotesChange({ target: { value: val } });
            }}
            modules={{
              clipboard: {
                matchVisual: false,
              },
            }}
          />
        </div>
      ) : (
        <div>
          <ReactQuill
            value={releaseNotes}
            theme="snow"
            onChange={(newValue) => {
              const val = newValue === '<p><br></p>' ? '' : newValue;
              handleReleaseNotesChange({ target: { value: val } });
            }}
            modules={{
              clipboard: {
                matchVisual: false,
              },
            }}
          />
        </div>
      )}
    </div>
  );
}

export default ReleaseNoteEditor;
